import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

Object.assign(pageTitleStyles, {
    titleText: {
        variant: "h1",
        css: css`
            font-size: 24px !important;
            line-height: 32px !important;
            font-weight: ${TYPOGRAPHY.weight.black} !important;
        `,
    },
    container: {
        gap: 0,
        offsetCss: css`
            max-width: 100%;
        `,
        css: css`
            margin-bottom: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 0px;
                    `,
                    css`
                        padding-top: 0px;
                    `,
                    null,
                    null,
                    null,
            ])}
        `,
    },
    brandStyles: {
        logoImage: {
            css: css`
                background: none;
                padding: 0 !important;
                img {
                    max-width: 150px;
                    max-height: 150px;
                }
                p {
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    font-size: ${TYPOGRAPHY.size.large};
                    line-height: 24px;
                    padding: 0 !important;
                    margin-bottom: 10px;
                }
            `,
        },
        nameText: {
            size: 16,
            weight: "normal",
        },
        nameLink: {
            css: css`
                span {
                    color: ${getProp("theme.typography.p.color")} !important;
                }
            `,
        },
    },
});
